<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:reportName="reportName"
		:getFiltersParams="getFiltersParams"
		:initFilters="initFilters"
		:customSaleNewSearchParams="customSaleNewSearchParams"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'
		:reportFormUrl="reportFormUrl">
		<FiltersBox :customSaleNewSearchParams="customSaleNewSearchParams" slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/customSaleNew.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapNew.vue'
import FiltersBox from '@/components/reportform/customSaleNew/FiltersBox.vue'
export default {
	name: 'customSaleNew',
	components: {
		reportFormWrap,
		FiltersBox
	},
	data () {
		return {
			reportid: 'REPORT_KHXS_000001',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/getCustomerSaleReport`,
			orderMenu: orderMenu,
			reportName: 'customSaleNew',
			customSaleNewSearchParams: {}
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (from && from.path && from.path.indexOf('/reportform/customGoodDetail') !== -1) {
				let customSaleNewSearchParams = window.localStorage.getItem('customSaleNewSearchParams')
				if (customSaleNewSearchParams) {
					vm.customSaleNewSearchParams = JSON.parse(customSaleNewSearchParams)
				}
			} else {
				vm.customSaleNewSearchParams = {}
			}
		})
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		initFilters () {
			this.$refs.filters.initFilters()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
